import avatar1 from "assets/images/user/1.png";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";

const devContent = [
  {
    devImg: avatar1,
    devName: "Field Auditors",
    devType: "Retail Execution & Compliance",
    avgRating: "4.9 (5M+ Audits)",
    rateLabel: "Outcome-Based",
    devPlace: "500+ Cities Active",
    tags: ["Audit", "On-Field", "SLA-Backed"]
  },
  {
    devImg: avatar1,
    devName: "Telecalling Partners",
    devType: "Vernacular Call Operations",
    avgRating: "4.8 (10M+ Calls)",
    rateLabel: "Pay Per Output",
    devPlace: "15+ Languages",
    tags: ["Support", "Telesales", "KYC Checks"]
  },
  {
    devImg: avatar1,
    devName: "Delivery Executives",
    devType: "Last-mile Hyperlocal Logistics",
    avgRating: "4.7 (15M+ Deliveries)",
    rateLabel: "On-demand Variable",
    devPlace: "13,000+ Pin codes",
    tags: ["Delivery", "Logistics", "On-demand"]
  },
  {
    devImg: avatar1,
    devName: "Business Development Agents",
    devType: "Merchant & User Acquisition",
    avgRating: "4.9 (2M+ Onboardings)",
    rateLabel: "Per Merchant Pay",
    devPlace: "PAN India",
    tags: ["Acquisition", "Merchant Sales", "Field Ops"]
  },
  {
    devImg: avatar1,
    devName: "Cataloging Specialists",
    devType: "E-Commerce Content Operations",
    avgRating: "4.8 (3M+ SKU Listings)",
    rateLabel: "Per SKU Uploaded",
    devPlace: "Remote Hybrid",
    tags: ["Data Entry", "Cataloging", "Product Listing"]
  },
  {
    devImg: avatar1,
    devName: "Verification Experts",
    devType: "Physical & Digital Trust Audits",
    avgRating: "4.9 (8M+ Checks)",
    rateLabel: "SLA Guaranteed",
    devPlace: "Instant Delivery",
    tags: ["KYC Check", "Trust", "Background Check"]
  }
];

const options = {
  items: 5,
  margin: 30,
  dots: false,
  nav: true,
  smartSpeed: 2000,
  navText: [
    '<i class="fas fa-chevron-left"></i>',
    '<i class="fas fa-chevron-right"></i>',
  ],
  loop: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 3,
    },
    1170: {
      items: 4,
    },
  },
};

const Developer = () => {
  return (
    <section className="section developer">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12 mx-auto">
            <div className="section-header aos" data-aos="fade-up">
              <h2 className="header-title">Managed Gig Workforce Profiles</h2>
              <p>Deploy curated gig workers optimized for quality and scale with outcomes-based pricing</p>
            </div>
          </div>
        </div>

        <OwlCarousel
          id="developers-slider"
          className="owl-carousel owl-theme developers-slider aos"
          loop
          {...options}
        >
          {!!devContent?.length &&
            devContent?.map((dev, i) => {
              return (
                <div className="freelance-widget" key={i}>
                  <div className="freelance-content">
                    <div className="freelance-img">
                      <Link to="/register">
                        <img src={dev?.devImg} alt="user_image" />
                        <span className="verified">
                          <i className="fas fa-check-circle"></i>
                        </span>
                      </Link>
                    </div>
                    <div className="freelance-info">
                      <h3>
                        <Link to="/register">{dev?.devName}</Link>
                      </h3>
                      <div className="freelance-specific text-primary">{dev?.devType}</div>
                      <div className="rating">
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <span className="average-rating ms-2">{dev?.avgRating}</span>
                      </div>
                      <div className="freelance-tags">
                        {dev?.tags?.map((tag, tIdx) => (
                          <span key={tIdx} className="badge badge-pill badge-design me-1 mb-1">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <div className="freelance-blk-location mt-2">
                        <div className="freelancers-price">{dev?.rateLabel}</div>
                        <div className="freelance-location">
                          <i className="fas fa-map-marker-alt me-1 text-success" />{" "}
                          {dev?.devPlace}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cart-hover">
                    <Link
                      to="/register"
                      className="btn-cart"
                      tabIndex="-1"
                    >
                      Get Workforce
                    </Link>
                  </div>
                </div>
              );
            })}{" "}
        </OwlCarousel>
      </div>
    </section>
  );
};
export default Developer;
